import { Link } from "react-router-dom";
import { PAGES } from "../../../routeConfig";
import { AddressCard } from "./addressCard";
import { AddNewAddress } from "./AddNewAddress";
import { Fragment, useContext, useEffect, useState } from "react";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { isValidArray } from "../../../Layout/Common/common";
import { BacktoMyAccount } from "../backToMyAccount";
import AddressCardSkeleton from "../../../Skeleton/myWallet/addressCardSkeleton";
import { noAddressSvg } from "../../../assets/imageImport";
import { NoAddressBook } from "./noAddressBook";
import { GlobalContext } from "../../../Context/GlobalContext";

export const AddressBookList = () => {
  const [searchData, setSearchData] = useState(null);
  const { userId } = useAuth();
  const { getMyAddressBook } = useGlobalFunction();
  const { addressList, setAddressList } = useContext(GlobalContext);
  useEffect(() => {
    getAddressBook();
  }, []);
  const getAddressBook = async () => {
    var response = await getMyAddressBook();
    if (response) {
      {
        setAddressList(response);
        setSearchData(response);
      }
    } else setAddressList([]);
  };

  const handleDelete = async (id) => {
    try {
      if (id && id > 0) {
        var response = await axiosInstance.post("AddressBook/DeleteAddress", {
          id: parseInt(id),
          userId: String(userId),
        });
        if (response && response.data) {
          setAddressList(response.data);
          setSearchData(response.data);
        } else {
          setAddressList([]);
          setSearchData([]);
        }
      }
    } catch (e) {
      console.error("address book main", e);
    }
  };

  const handleSearch = (e) => {
    var str = e.target.value.toLowerCase();

    var filter = searchData.filter(
      (item) =>
        item.shipTo.toLowerCase().includes(str) ||
        item.attentionTo.toLowerCase().includes(str) ||
        item.address1.toLowerCase().includes(str) ||
        item.address2.toLowerCase().includes(str) ||
        item.suburb.toLowerCase().includes(str) ||
        item.state.toLowerCase().includes(str) ||
        item.postCode.toLowerCase().includes(str),
    );
    setAddressList(filter);
  };

  return (
    <section className="myAccount-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-lg-12">
            <div className="acc-header py-3">
              <div className="myaccount-address myAccount-header-inner">
                <h1 className="myaccount-title">Shipping Address Book</h1>
                <div className="order-invoice myFavoriteList">
                  <p>You can find your Address book list groups here</p>
                </div>
              </div>
              <div className="fav-search addNew-book">
                <div className="input-group orders-search p-0 m-0">
                  <i className="fa-solid fa-magnifying-glass" />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search List"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleSearch}
                  />
                </div>
                <div className="button-effect">
                  <Link
                    to={PAGES.MYADDRESSBOOK + "/add"}
                    className="btn btn-products theme-primary px-3 mt-2 mt-md-0 fs-14"
                  >
                    <i className="fa-solid fa-plus" /> Add New Address
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <TransitionGroup className={"row row-equal-coloumn"}>
          {addressList ? (
            isValidArray(addressList) ? (
              addressList.map((row, index) => (
                <CSSTransition key={row.id} timeout={500} classNames="fade">
                  <AddressCard data={row} handleDelete={handleDelete} />
                </CSSTransition>
              ))
            ) : (
              <CSSTransition key={0} timeout={500} classNames="fade">
                <div className="col-lg-12" key={0}>
                  <div className="wallet-nosaved-Card p-5 mt-4">
                    <NoAddressBook />
                  </div>
                </div>
              </CSSTransition>
            )
          ) : (
            Array.from({ length: 3 }).map((_, i) => (
              <CSSTransition key={i + 10} timeout={500} classNames="fade">
                <AddressCardSkeleton key={i} />
              </CSSTransition>
            ))
          )}
        </TransitionGroup>

        <BacktoMyAccount />
      </div>
    </section>
  );
};
